import { createStyles, Theme, withStyles, WithStyles } from "@material-ui/core";
import Footer from "./Footer";
import NavMenu from "./NavMenu";

type LayoutProps = WithStyles<typeof styles> & {
    children: JSX.Element;
};

const styles = (theme: Theme) =>
    createStyles({
        body: { paddingTop: theme.navbar.height },
        main: {
            display: "block",
            margin: "0 auto",
            maxWidth: theme.layout.maxWidth,
            width: "auto"
        }
    });

function Layout({ children, classes }: LayoutProps) {
    return (
        <div className={classes.main}>
            <NavMenu />
            <div className={classes.body}>{children}</div>
            <Footer />
        </div>
    );
}

export default withStyles(styles)(Layout);
